var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"datepicker-wrapper p1"},[_c('VueDatepicker',_vm._b({attrs:{"inline":_vm.inline,"monday-first":true,"full-month-name":true,"language":_vm.DatepickerLocalizationFi,"calendar-class":"calendar"},model:{value:(_vm._value),callback:function ($$v) {_vm._value=$$v},expression:"_value"}},'VueDatepicker',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }